export type Provider = 'codex' | 'antigravity' | 'zai';

export const PROVIDERS: Provider[] = ['codex', 'antigravity', 'zai'];

export interface QuotaResult {
  provider: Provider;
  ok: boolean;
  configured: boolean;
  summary: string;
  error?: string;
  data: ProviderQuotaData | null;
}

export interface CodexQuotaData {
  usedPercent: number;
  remainingPercent: number;
  windowMinutes: number;
  resetAt: number | null;
  planType: string | null;
}

export interface ModelQuotaInfo {
  modelName: string;
  displayName: string;
  remainingPercent: number;
  resetTime: string | null;
}

export interface AntigravityQuotaData {
  email: string;
  claudeQuotaPercent: number | null;
  geminiQuotaPercent: number | null;
  claudeResetTime: number | null;
  geminiResetTime: number | null;
  models: ModelQuotaInfo[];
}

export interface ZaiQuotaData {
  usedTokens: number;
  totalTokens: number;
  usedPercent: number;
  remainingPercent: number;
  planTier: string | null;
}

export type ProviderQuotaData = CodexQuotaData | AntigravityQuotaData | ZaiQuotaData;

export type OpenCodeAuth = Record<string, string | ProviderAuthData>;

export interface ProviderAuthData {
  type?: string;
  access?: string;
  refresh?: string;
  expires?: number;
  api_key?: string;
  token?: string;
}

export interface AntigravityAccount {
  email: string;
  refreshToken: string;
  projectId?: string;
  addedAt: string;
}

export interface AntigravityAccounts {
  accounts: AntigravityAccount[];
}
